// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'copy';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <path
      strokeLinecap='round'
      d='M12.379 3.667V1.71a.71.71 0 0 0-.711-.71H1.71a.71.71 0 0 0-.71.71v9.958a.71.71 0 0 0 .71.71h1.957'
    />
    <path d='M5.621 6.333a.71.71 0 0 1 .711-.71h9.957a.711.711 0 0 1 .711.71v9.957a.711.711 0 0 1-.71.711H6.331a.71.71 0 0 1-.71-.71z' />
  </g>
);

export const viewBox = '0 0 18 18';
